import { COLORS } from '@elo-kit/constants/general.constants'

// TODO: update with using createUseStyles
const commentsStyles = (theme) => ({
  lessonCommentsContainer: {
    '& .nav-link:not(.active)': {
      color: `${theme.linkColor || COLORS.eloBlue} !important`,
    },
  },
})

export default commentsStyles
